"use client";
import {Tabs, TabsProps} from "antd";
import {lazy, useEffect, useState} from "react";
import {AddressInterface} from "@/lib/type/address.type";
import {useAddressStore} from "@/lib/store/address.store";

const MyAddress = lazy(() => import("./my-address"));
const AddAddress = lazy(() => import("./add-address"));
const EditAddress = lazy(() => import("./edit-address"));


type Props = {
    address: AddressInterface[]
}

export default function Content({
                                    address
                                }: Props) {
    const [editAddress, setEditAddress] = useState<AddressInterface|undefined>();
    const [activeKey, setActiveKey] = useState<string>("1");
    const [items, setItems] = useState<TabsProps["items"]>([
        {
            key: "1",
            label: "我的地址",
            children: <></>
        },
        {
            key: "2",
            label: "添加地址",
            children: <></>
        },
        {
            key: "3",
            disabled: !editAddress,
            label: "修改地址",
            children: <></>
        }
    ]);
    const {setAddressList} = useAddressStore();
    useEffect(() => {
        setAddressList(address);
    }, [address]);
    const onChange = (key: string) => {
        setActiveKey(key);
        // if (key !== "3") setEditAddress(undefined);
    };
    useEffect(() => {
        editAddress && setActiveKey("3");
        setItems(old => {
            return old?.map(item => {
                if (item.key === "3") {
                    return {
                        ...item,
                        children: <EditAddress address={editAddress} setEditAddress={setEditAddress}
                                               setActiveKey={setActiveKey}/>,
                        disabled: !editAddress
                    };
                }
                return item;
            });
        });
    }, [editAddress]);

    useEffect(() => {
        setItems([
            {
                key: "1",
                label: "我的地址",
                children: <MyAddress setEditAddress={setEditAddress}
                                     setActiveKey={setActiveKey}/>
            },
            {
                key: "2",
                label: "添加地址",
                children: <AddAddress/>
            },
            {
                key: "3",
                disabled: !editAddress,
                label: "修改地址",
                children: <EditAddress address={editAddress} setEditAddress={setEditAddress}
                                       setActiveKey={setActiveKey}/>
            }
        ]);
    }, []);
    return <Tabs activeKey={activeKey} items={items} onChange={onChange}/>;
}
